module.exports = __webpack_public_path__ + "images/js.77f201fa.png";